const PWA_ICON_192 = '/assets/icon/pwa-icon-192.png';
const PWA_ICON_512 = '/assets/icon/pwa-icon-512.png';

function ensureMeta(name, content) {
  if (typeof document === 'undefined') return;
  let meta = document.head.querySelector(`meta[name="${name}"]`);
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute('name', name);
    document.head.appendChild(meta);
  }
  meta.setAttribute('content', content);
}

function appendLink(attributes) {
  if (typeof document === 'undefined') return;
  const link = document.createElement('link');
  Object.entries(attributes).forEach(([key, value]) => {
    if (value != null && value !== '') link.setAttribute(key, value);
  });
  document.head.appendChild(link);
}

export function installPwaIconLinks() {
  if (typeof document === 'undefined') return;

  // iOS Safari uses apple-touch-icon for the Home Screen icon and may fall back
  // to favicon when this tag is missing or points to the old favicon image.
  document.head
    .querySelectorAll('link[rel="apple-touch-icon"], link[rel="apple-touch-icon-precomposed"]')
    .forEach((node) => node.parentNode?.removeChild(node));

  appendLink({ rel: 'apple-touch-icon', sizes: '192x192', href: PWA_ICON_192 });
  appendLink({ rel: 'apple-touch-icon-precomposed', sizes: '192x192', href: PWA_ICON_192 });

  // Keep favicon untouched, but make the install manifest explicit for Android/PWA.
  if (!document.head.querySelector('link[rel="manifest"]')) {
    appendLink({ rel: 'manifest', href: '/manifest.json' });
  }

  ensureMeta('mobile-web-app-capable', 'yes');
  ensureMeta('apple-mobile-web-app-capable', 'yes');
  ensureMeta('apple-mobile-web-app-title', 'NightPokerClub');
  ensureMeta('application-name', 'NightPokerClub');
  ensureMeta('theme-color', '#000000');

  // Expose paths for quick console/server-side verification without touching favicon.
  window.__NPC_PWA_ICONS__ = {
    icon192: PWA_ICON_192,
    icon512: PWA_ICON_512,
  };
}

installPwaIconLinks();
